module.exports = __webpack_public_path__ + "media/demo2.c05929c1.mp4";